import { Role } from './role.model';

export class User {
  public id?: string;
  public firstName?: string;
  public lastName?: string;
  public docType?: string;
  public docNumber?: string;
  public email?: string;
  public phone?: string;
  public charge?: string;
  public roles?: Role[];

  constructor(user: {
    id?: string;
    firstName?: string;
    lastName?: string;
    docType?: string;
    docNumber?: string;
    email?: string;
    phone?: string;
    charge?: string;
    roles?: Role[];
  }) {
    this.id = user.id;
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.docType = user.docType;
    this.docNumber = user.docNumber;
    this.email = user.email;
    this.phone = user.phone;
    this.charge = user.charge;
    this.roles = user.roles;
  }
}
